/******************************************************************************
 * FILE: src/modules/wms/services/wmsTemplateService.js
 * MODULE: Work Management System (WMS)
 * FEATURE: Template Management API Service
 *
 * PURPOSE:
 * Frontend API client for Template Management
 *
 * BACKEND:
 * /api/wms/templates
 *****************************************************************************/

import axiosClient from "../../../api/axiosClient";

/**
 * ----------------------------------------------------------------------
 * LIST TEMPLATES
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/templates
 */
async function listTemplates(params = {}) {

  const res = await axiosClient.get(
    "/api/wms/templates",
    { params }
  );

  const payload = res.data?.data || {};

  return {
    items: payload.data || [],
    pagination: payload.pagination || {},
  };
}

/**
 * ----------------------------------------------------------------------
 * GET TEMPLATE
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/templates/:id
 */
async function getTemplate(templateId) {

  const res = await axiosClient.get(
    `/api/wms/templates/${templateId}`
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * CREATE TEMPLATE
 * ----------------------------------------------------------------------
 * Backend:
 * POST /api/wms/templates
 */
async function createTemplate(payload) {

  const res = await axiosClient.post(
    "/api/wms/templates",
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * UPDATE TEMPLATE
 * ----------------------------------------------------------------------
 * Backend:
 * PUT /api/wms/templates/:id
 */
async function updateTemplate(
  templateId,
  payload
) {

  const res = await axiosClient.put(
    `/api/wms/templates/${templateId}`,
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * DELETE TEMPLATE
 * ----------------------------------------------------------------------
 * Backend:
 * DELETE /api/wms/templates/:id
 */
async function deleteTemplate(templateId) {

  const res = await axiosClient.delete(
    `/api/wms/templates/${templateId}`
  );

  return res.data;
}

/**
 * ----------------------------------------------------------------------
 * GET TEMPLATE ITEMS
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/templates/:id/items
 */
async function getTemplateItems(templateId) {

  const res = await axiosClient.get(
    `/api/wms/templates/${templateId}/items`
  );

  return res.data.data || [];
}

/**
 * ----------------------------------------------------------------------
 * CREATE TEMPLATE ITEM
 * ----------------------------------------------------------------------
 * Backend:
 * POST /api/wms/templates/:id/items
 */
async function createTemplateItem(
  templateId,
  payload
) {

  const res = await axiosClient.post(
    `/api/wms/templates/${templateId}/items`,
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * UPDATE TEMPLATE ITEM
 * ----------------------------------------------------------------------
 * Backend:
 * PUT /api/wms/templates/:templateId/items/:itemId
 */
async function updateTemplateItem(
  templateId,
  itemId,
  payload
) {

  const res = await axiosClient.put(
    `/api/wms/templates/${templateId}/items/${itemId}`,
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * DELETE TEMPLATE ITEM
 * ----------------------------------------------------------------------
 * Backend:
 * DELETE /api/wms/templates/:templateId/items/:itemId
 */
async function deleteTemplateItem(
  templateId,
  itemId
) {

  const res = await axiosClient.delete(
    `/api/wms/templates/${templateId}/items/${itemId}`
  );

  return res.data;
}

/**
 * ----------------------------------------------------------------------
 * EXPORT
 * ----------------------------------------------------------------------
 */
const wmsTemplateService = {

  listTemplates,
  getTemplate,

  createTemplate,
  updateTemplate,
  deleteTemplate,

  getTemplateItems,
  createTemplateItem,
  updateTemplateItem,
  deleteTemplateItem,
};

export default wmsTemplateService;